import axiosBase from 'axios'

const endpoint = process.env['REACT_APP_BASE_URL']

const axiosInstance = axiosBase.create({
  baseURL: endpoint,
})

export { axiosInstance }
